import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPodcast$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPodcast extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e75fce1c09dc8aea1f07437f89ffe5f4e18fb537', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8f87ef2c8a3046f14654d96031da7780c71e9e14', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '280ef7e672d2b7b5905ac6a2b35b008e546d1ade', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.09 15.24a6.4 6.4 0 0 1-1.57-3.84 6.68 6.68 0 0 1 6.39-6.9 6.49 6.49 0 0 1 5 10.74.5.5 0 0 0 0 .69l.36.36a.5.5 0 0 0 .72 0 8 8 0 1 0-12 0 .51.51 0 0 0 .73 0l.35-.36a.51.51 0 0 0 .02-.69M11 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.25 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm3.15-3A3 3 0 0 0 11 8a2.94 2.94 0 0 0-2.9 3 3.2 3.2 0 0 0 .6 1.8.51.51 0 0 1-.07.67l-.33.33a.5.5 0 0 1-.77-.07A4.4 4.4 0 1 1 15.4 11a4.68 4.68 0 0 1-.94 2.79.5.5 0 0 1-.76.06l-.33-.33a.51.51 0 0 1-.07-.67 3.2 3.2 0 0 0 .6-1.85", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-podcast", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-podcast"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-podcast":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPodcast$1);
            }
            break;
    } });
}

const CosmosIconPodcast = CosmosIconPodcast$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPodcast, defineCustomElement };
